// extracted by mini-css-extract-plugin
module.exports = {"card":"ServiceCard_card__nnoje","container":"ServiceCard_container__-oEaF","info":"ServiceCard_info__ELFLm"};